export function money(cents, opts = {}) {
  if (cents == null || isNaN(cents)) return "—";
  const sign = cents < 0 ? "-" : "";
  const abs = Math.abs(cents) / 100;
  return sign + "$" + abs.toLocaleString("en-US", {
    minimumFractionDigits: opts.cents ? 2 : 0,
    maximumFractionDigits: opts.cents ? 2 : 0,
  });
}

export function moneyExact(cents) {
  return money(cents, { cents: true });
}

export function fmtDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso.length === 10 ? iso + "T12:00:00" : iso);
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

export const STATUS_TONE = {
  PAID: "green", FUNDED: "green", ON_TRACK: "green", RECONCILED: "green", APPROVED: "green",
  COMPLETE: "green", ACTIVE: "green", CONNECTED: "green", RESOLVED: "green", FILED: "blue",
  SCHEDULED: "blue", READY_TO_FILE: "blue", PROCESSING: "blue", AUTHORIZED: "blue",
  AWAITING_CLIENT_APPROVAL: "blue", IN_PROGRESS: "yellow", UPCOMING: "yellow", SHORTFALL: "yellow",
  REVIEW_REQUIRED: "yellow", AUTHORIZATION_REQUIRED: "yellow", ACTION_REQUIRED: "yellow",
  OPEN: "yellow", TRIAL: "yellow", DRAFT: "gray", NOT_STARTED: "gray", NOT_CONNECTED: "gray",
  PAST_DUE: "red", FAILED: "red", DELINQUENT: "red", SUSPENDED: "red", CANCELLED: "red",
};

export const TONE_CLASSES = {
  green: "bg-emerald-100 text-emerald-800 border-emerald-200",
  yellow: "bg-amber-100 text-amber-800 border-amber-200",
  red: "bg-rose-100 text-rose-800 border-rose-200",
  blue: "bg-sky-100 text-sky-800 border-sky-200",
  gray: "bg-slate-100 text-slate-600 border-slate-200",
};

export function toneFor(status) {
  return TONE_CLASSES[STATUS_TONE[(status || "").toUpperCase().replace(/ /g, "_")] || "gray"];
}

export const PROVIDER_LABELS = {
  stripe: "Stripe", square: "Square", clover: "Clover", shopify: "Shopify", paypal: "PayPal",
  quickbooks: "QuickBooks", toast: "Toast", bank_feed: "Bank Feed", ach: "ACH Provider",
};
